import React, { Component } from 'react';
import {
    MediaPlayer as MLBMediaPlayer,
    MediaItem as PlayerMediaItem,
    MediaConfigUtil as MLBMediaConfigUtil,
    Messages,
    MediaPlayerEvents,
    Log,
} from 'mlb-media-player';
import _get from 'lodash/get';
import _assign from 'lodash/assign';
import cx from 'classnames';
import PropTypes from 'prop-types';
import AbstractMediaItem from '../../models/abstract-media-item';
import AdContainer from '..//ad-container/ad-container';
import EmbedEvents from '../../enum/embed-events';

import './media-player.scss';

class MediaPlayer extends Component {

    /**
     *
     * @param {object} props
     * @consructor
     *
     */
    constructor(props) {

        super(props);

        /**
         *
         * @type {MLBPlayerPlugins.BandwagonAdapter|MediaPlayer.AbstractPlugin}
         *
         */
        this.bandwagonAdapter = undefined;

        /**
         *
         * @type {boolean}
         *
         */
        this.playerIsReady = undefined;

        this.shouldRequestPreroll = true;

        this.bandwagonAdapter - undefined;

        this.observationCenter = undefined;

        this.advertisingPlugin = undefined;

        this.adBlockedError = false;

        this.canAutoplay = false;

        this.state = {
            adPlaying: false,
            forcePlaybackAfterUpdate: !this.props.autoplay,
            sentTracking: false,
            wasOnClick: false,
        };

    }

    componentDidMount() {

        this.createPlayer();

    }

    shouldComponentUpdate(nextProps, nextState) {

        const srcPath = 'clip.src';

        const isAdPlaying = this.state.adPlaying !== nextState.adPlaying;
        const isPropsUpdated = _get(this.props, srcPath) !== _get(nextProps, srcPath);
        const didChildrenUpdate = this.props.children !== nextProps.children;

        return isAdPlaying || isPropsUpdated || didChildrenUpdate;

    }

    componentDidUpdate(prevProps) {

        const playerIsReady = this.playerIsReady;
        const {
            clip,
            wasClickToPlay,
        } = this.props;
        const { adPlaying } = this.state;
        const idPath = 'clip.contentId';
        const isMediaUpdated = _get(this.props, idPath) != _get(prevProps, idPath);
        const shouldUpdatePlayerSource = playerIsReady && isMediaUpdated;
        const shouldRequestPlayback = playerIsReady && wasClickToPlay && !adPlaying;

        if (shouldUpdatePlayerSource) {

            this.updatePlayerSource();

            if (this.chartBeatPlugin) {

                this.chartBeatPlugin.setMetadata(clip);

            }

            this.publishMessage(EmbedEvents.META_DATA_LOADED, clip);

            return;

        }

        if (shouldRequestPlayback) {

            console.info('request ad or playback', playerIsReady, wasClickToPlay);
            this.requestAdOrPlayback(clip);

        }


    }

    requestAdOrPlayback(clip) {

        console.info('requestAdOrPlayback() - shouldRequestPreroll, advertisingPlugin', !!this.shouldRequestPreroll, !!this.advertisingPlugin);

        const shouldRequestPreroll = (
            this.advertisingPlugin
            && this.shouldRequestPreroll
        );

        if (shouldRequestPreroll) {

            this.advertisingPlugin.requestAd(clip);

        } else {

            this.mediaPlayer.play()
                .then((success) => {

                    console.info('requestAdOrPlayback() play then', success);

                })
                .catch((err) => {

                    console.info('requestAdOrPlayback() play catch', err);

                });

        }

    }

    setConvivaData(metaData) {

        const pluginManager = this.mediaPlayer.pluginManager;
        this.convivaPlugin = pluginManager.getPlugin('ConvivaPlugin');

        // Update chartbeat too...if it exists
        if (this.chartBeatPlugin) {

            this.chartBeatPlugin.setMetadata(metaData);

        }

    }

    /**
     *
     * @desc updates the player src based on props
     *
     */
    updatePlayerSource() {

        const {
            clip,
            wasClickToPlay,
        } = this.props;

        const mediaItemObj = {
            locale: _get(clip, 'locale'),
            poster: _get(clip, 'poster.src'),
            src: _get(clip, 'src'),
            metaData: _get(clip, 'data'),
            vttItems: _get(clip, 'vttItems'),
        };

        const mediaItem = new PlayerMediaItem(mediaItemObj);

        return this.mediaPlayer.setMediaItem(mediaItem)
            .then(() => {

                const { adPlaying } = this.state;

                const playerIsReady = this.playerIsReady;

                const shouldRequestPlayback = playerIsReady && clip && !adPlaying;

                const canAutoplay = this.canAutoplay;

                const canPlay = wasClickToPlay || canAutoplay;

                if (playerIsReady) {

                    this.mediaPlayer.pause();

                }

                // Request a new ad if one isn't playing already
                if(!adPlaying) {

                    this.shouldRequestPreroll = !this.adBlockedError;

                }

                if (shouldRequestPlayback && canPlay) {

                    // Attempt to call play
                    // TODO: check live playback - should happen in ad error or complete...
                    return this.requestAdOrPlayback(clip);

                } else {

                    this.publishMessage(EmbedEvents.SHOW_CLICK_TO_PLAY, null);

                    console.table('set media item', {
                        playerIsReady: playerIsReady,
                        wasClickToPlay,
                        canAutoplay,
                        adPlaying,
                        clip: !!clip,
                    });

                }

            })
            .then(() => {

                if(_get(clip, 'isLive')) {

                    this.mediaPlayer.jumpToLive();

                }

            })
            .catch((error) => {

                console.info(error.name, error.message, error);

            });

    }

    getMediaPlayerConfig() {

        const {
            mediaConfig,
            clip,
            preload,
            autoplay,
            shouldPlayInline,
            mute,
            loop,
            width,
            height,
            deviceInfo,
            playerId,
        } = this.props;

        const isMobile = [
            'tablet',
            'phone',
        ].indexOf(deviceInfo.formFactor) > -1 ? true : false;

        let config = {};

        _assign(config, mediaConfig, {
            playerTypeConfig: {
                domTarget: playerId,
                description: _get(clip, 'description'),
                subtitle: _get(clip, 'subtitle'),  // Not sure if this is needed for the app, it's not for the player
                thumb: _get(clip, 'image.src'), // Not sure if this is needed for the app, it's not for the player
                title: _get(clip, 'title'), // Not sure if this is needed for the app, it's not for the player
                controls: isMobile,
                preload,
                autoplay,
                shouldPlayInline,
                mute,
                loop,
                width,
                height,
                deviceInfo,
                ...mediaConfig.playerTypeConfig,
            },
        });

        return MLBMediaConfigUtil.create(config);

    }

    getAdPlugin(pluginManager, mediaConfig) {

        const { playerId } = this.props;
        const isFreewheelSite = _get(mediaConfig, 'videocore.advertising.freewheel.isFreeWheelSite');
        const pluginType = isFreewheelSite ? 'FreewheelPlugin' : 'DfpPlugin';
        const pluginNameKey = `${pluginType}-${playerId}`;
        const adPlugin = pluginManager.getPlugin(pluginNameKey);

        if (!adPlugin) {

            console.info(`No plugin found for type ${pluginType}!`);

        }

        return adPlugin;

    }

    /**
     *
     * @desc Publish embed specific messages on the player subject & bandwagonAdapter
     * @param message {string} The message to send
     * @param payload {object} The payload to send as data
     *
     */
    publishMessage(message, payload, bandwagon = true) {

        const { embedSubject } = this.observationCenter;

        if (embedSubject) {

            embedSubject.next({
                type: message,
                data: payload,
            });

        }


        // For legacy embeds
        /* if(bandwagon && this.bandwagonAdapter) {

            this.bandwagonAdapter.publishMessage(message, payload);

        } */

    }

    /**
     *
     * @desc Creates the media player
     * @todo update how we're getting the initial media metadata
     *
     */
    createPlayer() {

        let pluginManager;

        this.config = this.getMediaPlayerConfig();
        this.mediaPlayer = new MLBMediaPlayer(this.config);
        this.observationCenter = this.mediaPlayer.observationCenter;
        this.subscribeToPlayerSubject();
        this.subscribeToPlugInSubject();

        this.props.onMediaPlayerReady(this.mediaPlayer);

        // Inform the API the player has been created
        this.publishMessage(EmbedEvents.EMBED_PLAYER_CREATED, null);

        return this.mediaPlayer.initPlayer()
            .then((result) => {

                const canAutoplayWithSound = _get(this, 'mediaPlayer.player.features.autoplay.regular', false);
                const canAutoplayMuted = _get(this, 'mediaPlayer.player.features.autoplay.muted', false);
                const shouldAutoplay = _get(this, 'config.playerTypeConfig.autoPlay', false);

                this.canAutoplay = shouldAutoplay && (canAutoplayWithSound || canAutoplayMuted);

                const {
                    mediaConfig,
                    clip,
                } = this.props;

                // Get the pluginManager and bandwagonAdapter
                pluginManager = this.mediaPlayer.pluginManager;

                this.bandwagonAdapter = pluginManager.getPlugin('BandwagonAdapter');

                this.advertisingPlugin = this.getAdPlugin(pluginManager, mediaConfig);

                // Get Analytics Plugins
                this.chartBeatPlugin = pluginManager.getPlugin('ChartBeatPlugin');

                this.playerIsReady = true;

                // Set the player source
                this.updatePlayerSource()
                    .then(() => {

                        if (!this.state.sentTracking) {

                            this.setState({
                                sentTracking: true,
                            });

                        }
                        if (this.canAutoplay) {

                            this.publishMessage(EmbedEvents.EMBED_PLAYER_READY, null);

                        } else {

                            this.publishMessage(EmbedEvents.EMBED_PREVIEW_READY, null);

                        }

                        if (clip) {

                            // let the parent frame know about the metadata
                            // TODO: migrate to subject/observer & map to bandwagon in the embed library
                            this.publishMessage(EmbedEvents.META_DATA_LOADED, clip);

                        }

                    })
                    .catch((error) => {

                        console.info('Error updating source', error);

                    });

            });

    }

    subscribeToPlayerSubject() {

        const HTML5PlayerEvents = MediaPlayerEvents.HTML5;
        const mediaPlayerEvents = MediaPlayerEvents.MEDIA_PLAYER;

        // Map player events to embed events.
        this.observationCenter.playerSubject
            .subscribe((message) => {

                switch (message.type) {

                    case HTML5PlayerEvents.MEDIA_COMPLETE: {

                        this.shouldRequestPreroll = !this.adBlockedError;
                        this.props.onMediaComplete();
                        this.publishMessage(EmbedEvents.COMPLETE, message.data, false);
                        break;

                    }
                    case HTML5PlayerEvents.MEDIA_PAUSE: {

                        this.publishMessage(EmbedEvents.PAUSE, message.data, false);
                        break;

                    }
                    case HTML5PlayerEvents.MEDIA_RESUME: {

                        this.publishMessage(EmbedEvents.RESUME, message.data, false);
                        break;

                    }
                    case mediaPlayerEvents.MEDIA_REPLAY: {

                        this.shouldRequestPreroll = false;
                        this.publishMessage(EmbedEvents.REPLAY, message.data);
                        break;

                    }

                }


            });

    }

    resumePlaybackAfterAd(message) {

        const { isVisible } = this.props;
        this.setState({
            adPlaying: false,
        });

        // Only call play() if the player is ready
        //  Like when an ad plugin is enabled after the first play-though
        if (this.playerIsReady && isVisible) {

            this.mediaPlayer.play()
                .catch((error) => {

                    console.info('call to play after ad block or error failed', error);

                });

            this.publishMessage(EmbedEvents.START, message.data, false);

        }

    }

    subscribeToPlugInSubject() {

        this.observationCenter.pluginSubject
            .subscribe((message) => {

                if(!message) return;

                switch(message.type) {

                    case 'adLoaded': {

                        //this can be done later when we allow the access to the requestAdOrPlayback function of the plug-in?
                        //this.requestAdOrPlayback(this.videoAdNode);
                        break;

                    }
                    case 'adRequestStarted':
                    case 'adStart': {

                        this.mediaPlayer.pause();
                        this.shouldRequestPreroll = false;
                        this.setState({
                            adPlaying: true,
                        });
                        break;

                    }
                    case 'adRequestComplete': {

                        this.shouldRequestPreroll = false;
                        if(message.slots.length === 0) {

                            this.resumePlaybackAfterAd(message);

                        }
                        break;

                    }
                    case 'adComplete': {

                        this.shouldRequestPreroll = false;

                        this.resumePlaybackAfterAd(message);

                        break;

                    }
                    case 'adError': {

                        // A single ad failed, we can try again.
                        this.resumePlaybackAfterAd(message);

                        break;

                    }
                    case 'adPluginError':
                    case 'adBlockDetected': {

                        // Hard fail, no more ad requests
                        this.adBlockedError = true;
                        this.shouldRequestPreroll = false;
                        this.resumePlaybackAfterAd(message);

                        break;

                    }

                }

            });

    }

    replay() {

        this.mediaPlayer.replay();

    }

    stop() {

        if (this.state.adPlaying && this.advertisingPlugin) {

            console.debug('MediaPlayer stop() ad');
            this.advertisingPlugin.stop();
            this.shouldRequestPreroll = !this.adBlockedError;
            this.setState({
                adPlaying: false,
            });

        }

        console.debug('MediaPlayer stop() player');
        this.mediaPlayer.stop();
        this.mediaPlayer.observationCenter.playerSubject.next({ type: EmbedEvents.SHOW_CLICK_TO_PLAY });

    }

    render() {

        const { playerId } = this.props;
        const mediaPlayerClasses = cx('media-player', {
            'media-player--ad-in-progress': this.state.adPlaying,
        });

        return (
            <div id={playerId} className={mediaPlayerClasses} tabIndex="0" role="group" aria-label="MLB Media Player">
                <AdContainer playerId={playerId}/>
                {this.props.children}
            </div>
        );

    }

}

var generateConvivaViewerId = () => {

    let mlbOktaToken = (window.mlbOkta && window.mlbOkta.getToken('id_token'));
    return (mlbOktaToken && mlbOktaToken.clientId);

};

MediaPlayer.propTypes = {
    onMediaPlayerReady: PropTypes.func,
    onMediaComplete: PropTypes.func,
    clip: PropTypes.instanceOf(AbstractMediaItem),
    autoplay: PropTypes.bool,
    shouldPlayInline: PropTypes.bool,
    mediaConfig: PropTypes.object,
    deviceInfo: PropTypes.object,
    /** The unique id of the player */
    playerId: PropTypes.string.isRequired,
    wasClickToPlay: PropTypes.bool,
    isVisible: PropTypes.bool,
};

MediaPlayer.defaultProps = {
    onMediaComplete: () => null,
    onMediaPlayerReady: () => null,
    clip: null,
    autoplay: false,
    preload: true,
    mute: false,
    loop: false,
    width: null,
    height: null,
    deviceInfo: undefined,
    locale: 'en',
    wasClickToPlay: false,
    isVisible: true,
};

export default MediaPlayer;
